export default "__VITE_ASSET__DuAhwjew__"